// import Avatar from '../Avatar';
import { Avatar } from "@material-ui/core";
import { UserCard } from "../Card";
import withBadge from "../../badge/withBadge";
import React from "react";
import logo from "./logo.png";
import {
  MdClearAll,
  MdExitToApp,
  MdNotificationsActive,
  MdNotificationsNone,
  MdHome,
} from "react-icons/md";
import OutsideClickHandler from "react-outside-click-handler";
import PersonIcon from "@material-ui/icons/Person";
import {
  Button,
  ListGroup,
  ListGroupItem,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from "reactstrap";
import bn from "../../utils/bemnames";
import { getUser } from "../../../utlis";
import { GiAchievement } from "react-icons/gi";

const bem = bn.create("header");

const MdNotificationsActiveWithBadge = withBadge({
  size: "md",
  color: "primary",
  style: {
    top: -10,
    right: -10,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
  },
  children: <small>5</small>,
})(MdNotificationsActive);

class Header extends React.Component {
  state = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
    name: "",
    groupAdmin: "",
    palikaName: "",
  };
  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });
    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };
  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };
  handleSidebarControlButton = (event) => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector(".cr-sidebar").classList.toggle("cr-sidebar--open");
  };
  componentDidMount() {
    var user = getUser();
    console.log(user, "the user is");
    if (user) {
      if (user.groups.includes("PALIKAADMIN")) {
        const groupAdmin = user.groups;
        const name = user.palikaId.palika;
        console.log(name, "name ");
        this.setState({ name, groupAdmin });
      }
      if (user.groups.includes("WARDADMIN")) {
        const groupAdmin = user.groups;
        const name = user.ward.ward;
        console.log(name, "name ");
        console.log(user, "the ward admin is");
        this.setState({ name, groupAdmin, palikaName: user.palikaId.palika });
      }
    }
  }

  logoutHandler = () => {
    console.log("logout");
    localStorage.removeItem("user");
    window.location.replace("/login");
  };
  render() {
    const { isNotificationConfirmed } = this.state;

    return (
      <Navbar light expand className={bem.b("bg-white")}>
        <Nav navbar className="mr-2">
          {/* <Button outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={20} />
          </Button> */}
        </Nav>
        <Nav navbar className="mr-2" style={{ margin: "0 auto" }}>
          <img src={logo} style={{ height: "7vw" }} />
        </Nav>
        <Nav navbar className={bem.e("nav-right")}>
          <NavItem className="d-inline-flex">
            <NavLink className="position-relative">
              <a href="/achivements">
                <GiAchievement size={25} className="text-secondary can-click" />
              </a>
            </NavLink>
          </NavItem>
          <NavItem className="d-inline-flex">
            <NavLink className="position-relative">
              <a href="/">
                <MdHome size={25} className="text-secondary can-click" />
              </a>
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink id="Popover2">
              <Avatar>
                <PersonIcon onClick={this.toggleUserCardPopover} />
              </Avatar>
            </NavLink>

            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250 }}
            >
              <OutsideClickHandler
                onOutsideClick={() =>
                  this.setState({ ...this.state, isOpenUserCardPopover: false })
                }
              >
                <PopoverBody className="p-0 border-light">
                  <UserCard
                    title={getUser() ? getUser().username : ""}
                    subtitle={getUser() ? getUser().fullname : ""}
                    className="border-light"
                  >
                    <ListGroup flush>
                      <a href="/viewprofile" style={{ textDecoration: "none" }}>
                        <ListGroupItem
                          tag="button"
                          action
                          className="border-light"
                        >
                          Update Profile
                        </ListGroupItem>
                      </a>
                      <ListGroupItem
                        tag="button"
                        action
                        className="border-light"
                        onClick={this.logoutHandler}
                      >
                        <MdExitToApp /> Signout
                      </ListGroupItem>
                    </ListGroup>
                  </UserCard>
                </PopoverBody>
              </OutsideClickHandler>
            </Popover>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

export default Header;
